// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21QG6","left":"styles_left__2tGwm","desktopActions":"styles_desktopActions__2fMH8","title":"styles_title__2BLWl"};